<template>
  <b-container fluid>
    <backlink />
    <h1>Suivi des locations pour compte</h1>

    <AdminTable :config="config" :options="options" :items_provider="itemsProvider">
      <!-- Code couleur des lignes : ce que la liste doit faire remonter d'un coup d'œil,
           c'est l'échéance. Une location dont la fin prévue est dépassée alors que le
           matériel est toujours chez le client est une anomalie, pas un retard ordinaire. -->
      <template slot="remaining_days" slot-scope="{ data }">
        <span :class="deadlineClass(data.item)">
          <!-- L'API omet les clés nulles : une demande sans jours restants (close, refusée…)
               n'a pas la propriété du tout. Comparaison souple, sinon on affiche « undefined ». -->
          {{ data.item.remaining_days == null ? '' : data.item.remaining_days + ' j' }}
        </span>
      </template>
      <template slot="status_slug" slot-scope="{ data }">
        <b-badge :variant="data.item.status_variant">
          {{ data.value }}
        </b-badge>
      </template>
    </AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTableSync";
import config from "./config";

export default {
  name: "LocationForAccountList",
  components: {
    AdminTable,
  },
  data() {
    return {
      config: config,
    };
  },
  computed: {
    options: function () {
      const delay = this.$store.getters["location_for_account/getEndAlertDelay"];
      return {
        status_slug_options: this.$store.getters["location_for_account/getStatusTabs"],
        // Seuls les matériels de nature « Location pour compte » peuvent porter une demande,
        // et ils ont leur propre source : le catalogue les exclut.
        product_options: this.$store.getters["location_for_account/getProductsForSelect"],
        company_options: this.$store.getters["company/getByTypeCode"]("LOUR").selectOptions(
          "id",
          "name"
        ),
        deadline_options: [
          { value: "all", text: "Tout" },
          { value: "due_soon", text: "Arrive à terme (≤ " + delay + " j)" },
          { value: "overdue", text: "Dépassée" },
        ],
      };
    },
  },
  created() {
    this.$store.dispatch("location_for_account/getOptions");
    this.$store.dispatch("location_for_account/getProducts");
    this.$store.dispatch("company/getAllForSelect");
  },
  methods: {
    /**
     * Alimente AdminTableSync. Les onglets de statut et les filtres étendus arrivent tous
     * dans `extended_filters_model` : la liste ne distingue pas les deux, seul l'écran le fait.
     */
    itemsProvider(ctx) {
      const filters = ctx.extended_filters_model || {};
      const range = (name) => filters[name] || {};

      return this.$http
        .get(process.env.BACK_API_URL + "locationforaccount", {
          params: {
            page: ctx.currentPage,
            limit: ctx.perPage,
            sortBy: ctx.sortBy,
            sortDesc: ctx.sortDesc,
            search: ctx.filter,
            status: filters.status_slug,
            agency: filters.agency,
            business: filters.business,
            product: filters.product,
            company: filters.company,
            createdFrom: range("created").start,
            createdTo: range("created").end,
            startFrom: range("start").start,
            startTo: range("start").end,
            endFrom: range("end").start,
            endTo: range("end").end,
            deadline: filters.deadline,
          },
        })
        .then((response) => ({
          total: response.data.total,
          page: parseInt(response.data.page),
          // Le formatter de config.js remplace `status_slug` par son libellé avant le rendu :
          // la couleur du badge se calcule ici, tant que le slug est encore là.
          items: (response.data.locationForAccounts || []).map((item) => ({
            ...item,
            status_variant: this.$store.getters["location_for_account/getStatusVariant"](item.status_slug),
          })),
        }))
        .catch(() => {
          this.$toastr.error("Le chargement de la liste a échoué");
          return { total: 0, items: [] };
        });
    },
    deadlineClass(item) {
      if (item.deadline == "overdue") {
        return "lpc-deadline lpc-deadline--overdue";
      }
      if (item.deadline == "due_soon") {
        return "lpc-deadline lpc-deadline--soon";
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";

// Dépassement : la date de fin prévue est passée et le matériel est toujours chez le client.
// C'est l'anomalie que le SFD veut voir signalée, ici et par email.
.lpc-deadline {
  font-weight: 600;

  &--overdue {
    color: #d9534f;
  }

  &--soon {
    color: #e08e0b;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LocationForAccount/LocationForAccountList.vue